import ContactForm from '../components/ContactForm'

export default function Contact() {
  return (
    <main className="min-h-screen">
      {/* Page Header */}
      <section className="gradient-bg text-white py-16">
        <div className="section-container">
          <h1 className="text-4xl md:text-5xl font-display font-bold mb-4">Contact Us</h1>
          <p className="text-lg md:text-xl text-neutral-100 max-w-3xl">
            We're here to help. Reach out to our team for support, inquiries, or partnership
            opportunities.
          </p>
        </div>
      </section>

      {/* Contact Form */}
      <ContactForm />
    </main>
  )
}

